import { RootState } from "../../../RootReducer";

export const selectPlannerCollapsed = (state: RootState) => state.mapPage.header.plannerCollapsed;
